import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb, Empty, Table } from 'antd';

import { deleteProjectAsset, getAssetsByIpsLocationId } from '../../../api';
import Spinner, { spinnerOff, spinnerOn } from '../../../components/Spinner';
import { confirmAlert } from 'react-confirm-alert';
import { Row } from 'react-bootstrap';

import ProgressBar from 'containers/common/progress_bar';
import {
  SearchAndDropdownComponent,
  commonFilter,
  commonSorter,
  composeFilters,
  searchAndDropDownFilters,
  searchAndDropDownOnFilters,
} from 'utils/AntdTableFunctions';
import ProgressBarComp from 'containers/common/ProgressBarComp';

function AssetIpsSelected(props) {
  const [assets, setAssets] = useState(props.assets);
  // eslint-disable-next-line no-unused-vars
  const [ipsLocation, setIpslocation] = useState(
    props.location.ipsLocation ? props.location.ipsLocation : props.ipsLocation
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const { projectId, ipsLocationId } = props.match.params;
      const assetsData = await getAssetsByIpsLocationId({
        projectId,
        ipsLocationId,
      });

      setAssets(assetsData);

      setLoading(false);
    }
    getData();
    return () => setLoading(true);
  }, [props]);

  async function removeAsset(assetId) {
    spinnerOn();
    await deleteProjectAsset(assetId);
    const { projectId, ipsLocationId } = props.match.params;
    const assets = await getAssetsByIpsLocationId({
      projectId,
      ipsLocationId,
    });
    await props.refreshAssets(assets);
    spinnerOff();
  }

  function navigateToTasks(asset) {
    const { match } = props;
    const projectId = match.params.projectId;
    const projectStatus = match.params.state;
    props.history.push(
      `/${projectStatus}/${projectId}/assettasks/ipslocations/${asset.assetId}/tasks`
    );
  }

  const { match } = props;
  const projectId = match.params.projectId;
  const projectStatus = match.params.state;

  const sectionCellFormatter = (text, record) => {
    return record.deleteFlag === 'P' ? (
      <a
        href='#'
        onClick={() =>
          confirmAlert({
            title: 'Remove Asset',
            message:
              'This asset is flagged as "Verify IPS Data" because some information in IPS ' +
              'has changed to break the association in the Checklist. Removing the asset from the  ' +
              'Checklist will not effect the IPS Asset itself.',

            childrenElement: () => (
              <div>
                <br />
                For assistance, please contact your Construction Admin or visit
                the Checklist ShareNow page for documentation.
                <br />
                <a
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  href='https://sharenow.sp.aepsc.com/transmission/tfs/policies/checklist'
                >
                  https://sharenow.sp.aepsc.com/transmission/tfs/policies/checklist
                </a>
                <br />
                Are you sure you want remove the following Asset?
                <div>
                  <Row
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    Asset Name: {record.assetName}
                  </Row>
                  <Row
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    IPS Internal Ref. No.: {record.internalRef}
                  </Row>
                </div>
              </div>
            ),
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                  removeAsset(record.assetId);
                },
              },
              {
                label: 'No',
              },
            ],
          })
        }
        style={{ color: 'red', textDecoration: 'underline' }}
      >
        VERIFY IPS DATA
      </a>
    ) : record.deleteFlag === 'B' ? (
      <b>VERIFY IPS DATA</b>
    ) : (
      record.checkListSectionName
    );
  };
  const assetNameFormatter = (text, record) => {
    return (
      <a href='#' onClick={() => navigateToTasks(record)}>
        {text}
      </a>
    );
  };
  const preEFormFormatter = (text, record) => {
    return record.formId > 0 ? (
      <Link
        to={`/${projectStatus}/${projectId}/peform/${record.formId}/showTasks`}
      >
        {text}
      </Link>
    ) : (
      text
    );
  };
  const progressBarFormatter = (text, record, key) => {

    
      return <ProgressBarComp
        progressBarProps={[{ bgcolor: 'green', taskPercent: Number(record[`${key}Status`]).toFixed(2) },
        { bgcolor: 'gray', taskPercent: Number(record[`${key}InCompStatus`]).toFixed(2) },
        { bgcolor: 'yellow', taskPercent: Number(record[`${key}TempStatus`]).toFixed(2) }
        ]}
        style={{
          borderRadius: '.25rem',
          height: '1rem',
          overflow: 'hidden',
          fontSize: '.75rem',
          color: 'black',
          width: 100
        }}
        showtext={true}
      />
  
    // return text === null || (text && text < 0) ? (
    //   'N/A'
    // ) : text < 100 ? (
    //   <ProgressBar percentage={text} px={true} />
    // ) : (
    //   <ProgressBar percentage={text} color={'success'} px={true} />
    // );
  };
  const columns = [
    {
      dataIndex: 'checkListSectionName',
      key: 'checkListSectionName',
      title: 'Section',

      render: sectionCellFormatter,
      filters: composeFilters(
        'checkListSectionName',
        assets,
        'Asset_IPSLoc_selected'
      ),

      onFilter: (value, record) =>
        commonFilter(
          value,
          record,
          'checkListSectionName',
          'Asset_IPSLoc_selected'
        ),
      sorter: (a, b) =>
        commonSorter(a, b, 'checkListSectionName', 'Asset_IPSLoc_selected'),
    },
    {
      dataIndex: 'assetGroupName',
      key: 'assetGroupName',
      title: 'Asset Group',

      filters: composeFilters('assetGroupName', assets),

      onFilter: (value, record) =>
        commonFilter(value, record, 'assetGroupName'),
      sorter: (a, b) => commonSorter(a, b, 'assetGroupName'),
    },
    {
      dataIndex: 'assetName',
      key: 'assetName',
      title: 'Asset Name',

      render: assetNameFormatter,
      filters: searchAndDropDownFilters('assetName', assets),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'assetName'),

      sorter: (a, b) => commonSorter(a, b, 'assetName'),
    },

    {
      dataIndex: 'assetType',
      key: 'assetType',
      title: 'Asset Type',
      filters: searchAndDropDownFilters('assetType', assets),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'assetType'),

      sorter: (a, b) => commonSorter(a, b, 'assetType'),
    },
    {
      dataIndex: 'workOrder',
      key: 'workOrder',

      title: 'Work Order#',
      filters: searchAndDropDownFilters('workOrder', assets),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'workOrder'),

      sorter: (a, b) => commonSorter(a, b, 'workOrder'),
    },
    {
      dataIndex: 'internalRef',
      key: 'internalRef',
      title: 'Internal Ref#',
      filters: searchAndDropDownFilters('internalRef', assets),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'internalRef'),

      sorter: (a, b) => commonSorter(a, b, 'internalRef'),
    },
    {
      dataIndex: 'formName',
      key: 'formName',
      title: 'Pre-E Form',

      render: preEFormFormatter,
      filters: composeFilters('formName', assets),

      onFilter: (value, record) => commonFilter(value, record, 'formName'),

      sorter: (a, b) => commonSorter(a, b, 'formName'),
    },
    {
      dataIndex: 'preEngStatus',
      key: 'preEngStatus',
      title: 'Pre-Energization',

      render: (text, record) => progressBarFormatter(text, record, 'preEng'),
    },
    {
      dataIndex: 'inServStatus',
      key: 'inServStatus',
      title: 'In-Service',
      render: (text, record) => progressBarFormatter(text, record, 'inServ'),
    },
    {
      dataIndex: 'docStatus',
      key: 'docStatus',
      title: 'Documentation',
      render: (text, record) => progressBarFormatter(text, record, 'doc'),
    },
  ];

  return (
    <div className='container-fluid'>
      {/* <Row
        className='justify-content-middle'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          fontStyle: 'italic',
          fontWeight: 'bold',
          marginBottom: 12,
          marginTop: 20,
        }}
      >
        <i
          className='fa fa-info-circle'
          style={{ color: 'red', paddingRight: '3px' }}
          aria-hidden='true'
        ></i>{' '}
        Note: The % Calculations on this tab include tasks Signed and Marked
        N/A.
      </Row> */}

      <Breadcrumb className='breadcrumb-item'>
        <Breadcrumb.Item>
          <Link
            to={`/${projectStatus}/${projectId}/assettasks/ipslocations`}
            style={{ fontize: '30px' }}
          >
            IPS Locations
          </Link>{' '}
        </Breadcrumb.Item>
        {ipsLocation && <Breadcrumb.Item>{ipsLocation.name}</Breadcrumb.Item>}
      </Breadcrumb>
      <Spinner />

      <div className='row mb-5 '>
        <div className='table-responsive assets-task-container'>
          <br />
          <br />
          <Table
            columns={columns}
            dataSource={assets}
            pagination={false}
            locale={{
              emptyText: loading ? (
                <Empty description={<h6>Loading</h6>} />
              ) : (
                <Empty description={<h6>No IPS Locations Found</h6>} />
              ),
            }}
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(AssetIpsSelected);
